// 英文语言包
export default {
	email: {
		title: "Compose Email",
		replyTitle: "Reply Email",
		forwardTitle: "Forward Email",
		send: "Send",
		to: "To",
		cc: "Cc",
		bcc: "Bcc",
		subject: "Subject",
		addAttachment: "Add Attachment",
		camera: "Camera",
		photo: "Photo",
		video: "Video",
		attachment: "Browse",
		contactExists: "The contact already exists",
		noEmail: "The contact does not have an email",
		mailLoading: "Loading",
		all: "All",
		addressor: "Addressor",
		inbox: "Inbox",
		drafts: "Drafts",
		sentItems: " SentItems",
		deletedItems: " DeletedItems",
		junkEmail: " JunkEmail",
		detailTitle: "Details",
		replyAll: "Reply all",
		reply: "Reply",
		forward: "Forward",
		delete: "Delete",
		details: "Details",
		noSubject: "subjectless",
		when: "When",
		location: "Location",
		accept: "Accept",
		wait: "Wait",
		refuse: "Refuse",
		sendSuccess: "Send successfully",
		sendFailed: "Send failed",
		selectFiltered: "Some email accounts that have not been opened have been deleted"
	},
	delMail: {
		delConfirm: "Delete confirmed",
		delTip: "Are you sure about the deletion? After the deletion, the mobile phone cannot be restored using Outlook",
		delAll: 'Have you confirmed the deletion? It cannot be restored after being deleted.',
		delFailed: "Delete failed",
		delSuccess: "Deleted successfully"
	},
	writeMail: {
		saveTip: "Save as draft?",
		saveOk: "Yes",
		saveNo: "No",
		saveFail: "Save Failed",
		saveSuccess: "Saved successfully"
	},
	meeting: {
		operationSuc: "Operation successful",
		operationFail: "Operation failed",
		creatorOperateTip: "You are the meeting creator, no action required"
	},
	contactSearch: {
		noMoreData: "There's no more data",
		loading: "Loading",
		loadMore: "Click to load more"
	},
	attachment: {
		uploading: "Uploading",
		uploadFailed: "Upload failed",
		overMaxSize: "A maximum of 100M attachments can be uploaded",
		overFileMaxSize: "A single accessory cannot exceed 30M at most",
		noSupportPreview: "This file does not support preview"
	},
	common: {
		cancel: "Cancel",
		confirm: "Confirm",
		delet: 'Delet',
		hint: 'Hint',
		fnDevTip: "Function is being developed"
	},
	page404: {
		pageNotExist: 'Sorry, the page you visited does not exist',
		moreTip: 'This page has been deleted, or is under construction, please stay tuned',
		backHome: 'Back Homepage'
	},
	ajaxErr: {
		notLogin: 'User not logged in or login has expired!',
		networkErr: 'The network connection failed. Please check the network Settings.',
		isCancel: 'Request canceled.',
		apiRequestFail: 'Api request failed!',
		timeout: 'Operating frequency'
	},
	home: {
		seach: 'Search',
		end: 'Bottom of the page',
		loading: 'Loading...',
		success: 'Marked success',
		recipients: 'Recipient not filled in',
		subjectless: 'Subjectless',
		maxList: 'Maximum 100 emails'
	},
	header: {
		Inbox: 'Inbox',
		chooseEma: 'Choose Mail',
		all: 'All',
		deselectAll: 'Deselect All',
		sign: 'Sign',
		tagR: 'Mark as Read',
		tagW: 'Mark as Unread',
	},
	wx: {
		selectUserErr: "Address book call failed, please try again later!"
	},
	// 翻译
	translate: {
		selectTranslateLan: "Select translation language",
		translateEmail: "Translate email",
		translateing: "Translating...",
		translateFail: "Translation fail",
		showOrigin: "Display original text",
		showTranslate: "Display translation",
		translateTip: "The following content is translated by AI， just for reference"
	},
	isRead: {
		all: 'All',
		unread: 'Unread',
		read: 'Read'
	}
}
